/**
 * Color utilities for the Needs Map
 */

/**
 * Shadow levels for different states
 */
export const SHADOW = {
  DEFAULT: "shadow-md",
  SELECTED: "shadow-lg",
  HOVER: "shadow-md",
  PHASE_TAB: "shadow-sm",
};

/**
 * Convert hex color to rgba
 * @param hex Hex color code
 * @param alpha Alpha value (0-1)
 * @returns RGBA color string
 */
export function hexToRgba(hex: string, alpha: number = 1): string {
  // Remove # if present
  hex = hex.replace('#', '');
  
  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Return rgba string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Get node border color based on selection state
 * @param isSelected Whether the node is selected
 * @returns Border color as hex string
 */
export function getNodeBorderColor(isSelected: boolean = false): string {
  return isSelected 
    ? "#e2e8f0" // Slightly darker border for selected state
    : "#f1f5f9"; // Light border for normal state
}

/**
 * Get node shadow class based on state
 * @param isSelected Whether the node is selected
 * @returns Tailwind shadow class
 */
export function getNodeShadow(isSelected: boolean = false): string {
  return isSelected ? SHADOW.SELECTED : SHADOW.DEFAULT;
}


/**
 * Get phase chip color
 * @param phaseColor The base color for the phase
 * @returns Color as hex string
 */
export function getPhaseTabColor(phaseColor: string): string {
  return phaseColor; // Use full opacity for phase chip
}

/**
 * Get node background color based on active state
 * @param isActive Whether the node is active
 * @returns Background color as hex string
 */
export function getNodeBackgroundColor(isActive: boolean = true): string {
  return isActive 
    ? "#ffffff" // White for active nodes
    : "#f8fafc"; // Very light gray for inactive nodes
}

/**
 * Get node text color based on active state
 * @param isActive Whether the node is active
 * @returns Text color as hex string
 */
export function getNodeTextColor(isActive: boolean = true): string {
  return isActive 
    ? "#0f172a" // Dark text for active nodes
    : "#64748b"; // Muted text for inactive nodes
}